// extracted by mini-css-extract-plugin
module.exports = {"overview":"OrderOverview_overview__2uAIs"};